import React from "react";
import * as translator from "../../../../../utils/translator";
import MyAccountAccordion from "../../MyAccountAccordion/MyAccountAccordion";
import ArrowUp from "../../../../../icons/ArrowUp.svg";
import ArrowDown from "../../../../../icons/ArrowDown.svg";
// Reuse the order-details order-notes FAQ styling verbatim so this FAQ is
// visually identical (navy titles, divider lines, chevron icons).
import "../../MyAccountOrderDetails/MyAccountOrderDetails.css";
import { MyAccountStoreFaqItem } from "../types";

interface Props {
  language: string;
  titleTranslationKey: string;
  items: MyAccountStoreFaqItem[];
}

const MyAccountStoreFaq: React.FC<Props> = ({ language, titleTranslationKey, items }) => {
  if (!items || items.length === 0) return null;

  const title = translator.translate(language, "my_account", titleTranslationKey);

  const accordionItems = items.map((item) => ({
    title: translator.translate(language, "my_account", item.questionTranslationKey),
    content: translator.translate(language, "my_account", item.answerTranslationKey),
  }));

  return (
    <div className="account-order-notes">
      <h3 className="information-header">{title}</h3>
      <MyAccountAccordion
        items={accordionItems}
        accordionClass="information-accordion-container"
        itemClass="information-accordion-item"
        titleClass="information-accordion-title"
        contentClass="information-accordion-content"
        icons={{ closeIcon: ArrowUp, openIcon: ArrowDown }}
      />
    </div>
  );
};

export default MyAccountStoreFaq;
